export default "__VITE_ASSET__CPDC91Kq__"